module.exports = __webpack_public_path__ + "static/media/1.c2f6b688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Designbase/assets/1.jpg
// module id = 61
// module chunks = 0